import { useState } from "react";
import "./style.scss";
import { Outlet, useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { useTranslation } from "react-i18next";
import { AuthContactsModal } from "pages/onboarding/components/contacts-modal";
import { VerificationHeader } from "../components/header";
import { SaveProgressBottomsheet } from "../components/save-progress-bottomsheet";
import Modal from "widgets/auth/modal";
import { useStore } from "zustand";
import { sessionStore } from "entities/session/model/sessionModel";

export const VerificationLayout = () => {
  const { t } = useTranslation("onboarding-auth");
  const { t: a } = useTranslation("app");
  const { t: o } = useTranslation("onboarding");
  const navigate = useNavigate();
  const [chatOpened, setChatOpened] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const { reachedLimitModal, setReachedLimitModal } = useStore(sessionStore);

  return (
    <div className="verification-layout">
      <VerificationHeader
        openChat={() => setChatOpened(true)}
        close={() => {
          setSaveModal(true);
        }}
      />
      <Outlet />
      {chatOpened && (
        <AuthContactsModal localChat onClose={() => setChatOpened(false)} />
      )}
      {saveModal && (
        <SaveProgressBottomsheet
          save={() => navigate(PATH_LIST.home)}
          close={() => {
            setSaveModal(false);
          }}
        />
      )}
      {reachedLimitModal && (
        <Modal
          customModal="rate-limit-exceeded-modal"
          title={o("tooManyRequests")}
          text={o("tryAgain30min")}
          btnText={t("contactSupport")}
          btnText2={a("gotIt")}
          showSecondBtn
          onClick={() => navigate(PATH_LIST.chat)}
          onClickSecondBtn={() => setReachedLimitModal(false)}
          // onClick={() => (window.location.href = "mailto:support@siriuscapital.am")}
          onHide={() => setReachedLimitModal(false)}
        />
      )}
    </div>
  );
};
